import { faker } from '@faker-js/faker'

import { TreatmentReviewStatistic, TreatmentReviewStatistics } from '../../contracts/hospital/TreatmentReviewStatistics'
import { asBuilder } from '../asBuilder'

const createTreatmentStatistic = (): Omit<TreatmentReviewStatistic, 'rank'> => ({
  treatmentId: faker.number.int(),
  treatmentName: faker.lorem.word(),
  totalCount: faker.number.int({ min: 1, max: 1000 }),
  avgRating: faker.number.float({ min: 0.0, max: 10.0, precision: 0.1 }),
})

export const getTreatmentReviewStatistic = asBuilder((): TreatmentReviewStatistic[] => {
  const count = faker.number.int({ min: 1, max: 10 })
  const statistics = Array.from({ length: count }, createTreatmentStatistic)

  const sortedStats = statistics.sort((a, b) => b.totalCount - a.totalCount)

  let currentRank = 1
  let prevCount = sortedStats[0]?.totalCount

  return sortedStats.map((stat, index) => {
    if (index > 0 && stat.totalCount < prevCount) {
      currentRank = Math.min(currentRank + 1, 5)
      prevCount = stat.totalCount
    }

    return {
      ...stat,
      rank: currentRank,
    }
  })
})

export const getTreatmentReviewStatistics = asBuilder((): TreatmentReviewStatistics => {
  return {
    ratings: getTreatmentReviewStatistic().slice(0, 5),
  }
})
